import { React, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Feather, Menu } from "react-feather";
import OtherService from "../../services/Other";
import {
  getColor,
  getIcon,
  formatNumber,
} from "../../constants/commonFunction";
import { addContractorCount } from "../../redux/slices/currentUserSlice";
import BigBox from "../BigBox.js";
import Box from "../Box.js";
import FeatherIcon from "feather-icons-react";

const Performance = (props) => {
  const dispatch = useDispatch();
  const [hierName, setHiername] = useState(null);
  const [loyaltyData, setLoyaltyData] = useState([]);
  const [loading, setLoading] = useState(false);

  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;

  const trigger = async () => {
    const hierDesc = JSON.parse(localStorage.getItem("userData")).hierCode;
    setHiername(hierDesc);
    if (hierDesc == "Contractor") {
    }
    if (hierDesc == "TSE") {
      getTseContractorPerformanceData();
      getMonthlyEnrollment();
    }
  };

  useEffect(() => {
    setLoyaltyData([]);
    trigger();
  }, [brandId]);

  const getTseContractorPerformanceData = async () => {
    try {
      setLoading(true);
      const res = await OtherService.getTseContratorBusinessData();

      if (res.success === true) {
        const result = res?.response;
        props?.setCount(res?.response);
        dispatch(
          addContractorCount({
            contractorCount: result,
          })
        );
        const arr = [];
        for (let [key, value] of Object.entries(result)) {
          if (String(key).includes("total_contractors_count")) {
            arr.push({
              value: value,
              icon: getIcon(key),
              color: getColor(key),
              label: String(
                // key.split("_").slice(0, -2).join(" ") + "Contractors"
                "Total Contractors"
              ),
            });
          }
          if (String(key).includes("super_active_contractors_count")) {
            arr.push({
              value: value,
              icon: getIcon(key),
              color: getColor(key),
              label:
                // String(key.split("_").slice(0, -2).join(" ")) +
                // " (" +
                // result["super_active_contractors_percent"] +
                // " %)",
                String("Super Active") +
                " (" +
                result["super_active_contractors_percent"] +
                " %)",
            });
          }
          if (String(key) === "active_contractors_count") {
            arr.push({
              value: value,
              icon: getIcon(key),
              color: getColor(key),
              label:
                // String(key.split("_").slice(0, -2).join(" ")) +
                // " (" +
                // result["active_contractors_percent"] +
                // " %)",
                String("Active") +
                " (" +
                result["active_contractors_percent"] +
                " %)",
            });
          }
        }
        setLoyaltyData((loyaltyData) => [...loyaltyData, ...arr]);
      }
    } catch (err) {
      console.error("Contractor Count api error");
    } finally {
      setLoading(false);
    }
  };

  const getMonthlyEnrollment = async () => {
    try {
      // setLoading(true);
      let payload = {
        business_timeframe: "MTD",
        hierarchies: [],
      };
      const res = await OtherService.getTseMonthlyEnrollments(payload);
      if (res.success == true) {
        for (let [key, value] of Object.entries(res.response)) {
          if (key == "approved_count") {
            setLoyaltyData((loyaltyData) => [
              ...loyaltyData,
              ...[
                {
                  color: getColor(key),
                  value: value,
                  icon: getIcon(key),
                  label: "Monthly Enrollment",
                },
              ],
            ]);
          }
        }
      }
    } catch (err) {
      console.error("Monthly enrollment api error");
    }
  };

  return (
    <>
      <BigBox header="Loyalty Performance Tracker">
        {loading ? (
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              color: "#000",
              maxHeight: "112px",
              minWidth: "202px",
              minHeight: "112px",
            }}
          >
            <p className="text-[16px] text-slate-600 font-medium">Loading...</p>
          </div>
        ) : loyaltyData?.length > 0 ? (
          loyaltyData.map((item, index) => {
            const img = item?.icon;
            return (
              <>
                <Box column={2} bgColor={item?.color} key={index}>
                  <div
                    className="w-full"
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <div
                      className="flex justify-between items-center"
                      style={{
                        display: "flex",
                        flex: 3,
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <div>
                        <p className="text-3xl font-extrabold text-gray-900">
                          {item?.value}
                        </p>
                      </div>

                      <div>
                        <p
                          style={{ textAlign: "left" }}
                          className="text-base font-medium text-gray-700 mt-2"
                        >
                          {item?.label}
                        </p>
                      </div>
                    </div>
                    <div
                      className="flex justify-between items-center"
                      style={{
                        display: "flex",
                        flex: 1,
                        justifyContent: "flex-end",
                      }}
                    >
                      {String(img).includes(".png") ? (
                        <img
                          src={img}
                          alt=""
                          style={{
                            height: 28,
                            width: 28,
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <FeatherIcon icon={img} />
                      )}
                    </div>
                  </div>
                </Box>
              </>
            );
          })
        ) : (
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              color: "#000",
              maxHeight: "112px",
              minWidth: "202px",
              minHeight: "112px",
            }}
          >
            <p className="text-[18px] font-bold text-slate-600 text-center">
              No data found !!!
            </p>
          </div>
        )}
      </BigBox>
    </>
  );
};

export default Performance;
